const { ySyncPlugin, yCursorPlugin, yUndoPlugin, undo, redo } = Y.ProseMirrorBinding
const { PluginKey, Plugin } = ProseMirror.state
const { keymap } = ProseMirror.keymap

export const rmYjsPluginKey = new PluginKey('rmYjs')

export function proseMirrorYjsPlugins (yItem, updateItemFocus, canEditFieldCallback) {
  return [
    ySyncPlugin(yItem.get('details')),
    yCursorPlugin(yItem.doc.awareness),

    yUndoPlugin(),
    keymap({
      'Mod-z': undo,
      'Mod-y': redo,
      'Mod-Shift-z': redo,
    }),

    new Plugin({
      key: rmYjsPluginKey,
      view: view => {
        const yjsStyleSheet = document.createElement('style')
        yjsStyleSheet.innerHTML = styles
        view.root.append(yjsStyleSheet)
        return {
          destroy: () => {
            yjsStyleSheet.remove()
          }
        }
      },
      props: {
        editable: canEditFieldCallback,
        handleDOMEvents: {
          ...(typeof updateItemFocus === 'function' && {
            focus: () => updateItemFocus(true),
            blur: () => updateItemFocus(false),
          }),
        },
      },
    }),
  ]
}

const styles = `
/* this is a rough fix for the first cursor position when the first paragraph is empty */
.ProseMirror > .ProseMirror-yjs-cursor:first-child {
  margin-top: 16px;
}
/*.ProseMirror p:first-child, .ProseMirror h1:first-child, .ProseMirror h2:first-child, .ProseMirror h3:first-child, .ProseMirror h4:first-child, .ProseMirror h5:first-child, .ProseMirror h6:first-child {
  margin-top: 16px
}*/
/* This gives the remote user caret. The colors are automatically overwritten*/
.ProseMirror-yjs-cursor {
  position: relative;
  margin-left: -1px;
  margin-right: -1px;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-color: orange;
  word-break: normal;
  pointer-events: none;
}
/* This renders the username above the caret */
.ProseMirror-yjs-cursor > div {
  position: absolute;
  top: -1.05em;
  left: -1px;
  font-size: 13px;
  background-color: rgb(250, 129, 0);
  font-family: serif;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  user-select: none;
  color: white;
  padding-left: 2px;
  padding-right: 2px;
  white-space: nowrap;
}
`
